
import React from 'react';
import { useHistory } from 'react-router-dom';
import { raraweblogo } from '../../constants/iconImageConstant';
import { Header } from '../Header/Header';
import { Footer } from '../appFooter/Footer';


export function RaeaPage() {
  const history = useHistory();

  const handleNavigate = (path: string) => {
    history.push(path);
  };

  return (
    <>
      <Header />

      <div className="main-container">
        <main role="main" className="container-fluid">

          {/* Logo Section */}
          <div className="row">
            <div className="col-md-12">
              <div className="logo-pain-cont">
                <img
                  src={raraweblogo}
                  alt="RAEA Logo"
                />
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="container-fluid">
            <div className="col-md-12">
              <div className="row">

                {/* Left Content */}
                <div className="col-md-6">
                  <div className="abt_raea">

                    <p>
                      The Ramoji Animation Excellence Awards (RAEA) are inspired
                      by the visionary legacy of Sri Ramoji Rao, a pioneer who
                      transformed storytelling into a powerful cultural force.
                    </p>

                    <p>
                      Honoring excellence across key categories namely{' '}
                      <span>Best Young Animator 2026</span> and{' '}
                      <span>Best Indie Studio 2026.</span> RAEA recognizes
                      originality, collaboration and craftsmanship, inspiring
                      the next generation to push creative boundaries and
                      elevating Indian animation on the global stage.
                    </p>

                    <p>
                      Established to celebrate emerging talent and drive
                      innovation in India’s animation ecosystem, the debut
                      edition of the awards is being held on August 28, 2026,
                      in Mumbai.
                    </p>

                  </div>

                  <div className="text-center mt-3">
                    <a
                      href="https://annawards.com/event/national/"
                      className="ckm"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      CLICK TO KNOW MORE
                    </a>
                  </div>
                </div>

                {/* Right Video */}
                <div
                  className="col-md-6"
                  style={{ marginTop: '40px' }}
                >
                  <video
                    autoPlay
                    loop
                    playsInline
                    controls
                    width="100%"
                    className="video-frame"
                  >
                    <source
                      src="https://assets.etvbalbharat.com/video/RAMOJI_EXCELLENCE_AWARDS_TRAILER.mp4"
                      type="video/mp4"
                    />

                    Your browser does not support the video tag.
                  </video>
                </div>

              </div>
            </div>
          </div>

        </main>
      </div>

      <Footer />
    </>
  );
}

